import React from 'react';
import { HIDE_DESCRIPTION, VIEW_DESCRIPTION } from '../data/Localization';

/**
 * Renders a toggle button for showing or hiding card details.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {boolean} props.active - Indicates whether the card details are active or not.
 * @param {string} props.ariaText - The ARIA text for the toggle button.
 * @param {Function} props.onClick - The click event handler for the toggle button.
 * @returns {JSX.Element} The rendered toggle button component.
 */
function CardDetailsToggle(props) {
	const isActive = props.active;
	const viewDescIcon = isActive ? 'chevronDown' : 'chevronUp';
	const viewDescText = isActive ? VIEW_DESCRIPTION : HIDE_DESCRIPTION;
	// eslint-disable-next-line no-undef
	const viewDescAriaText = Granite.I18n.get(isActive ? 'View description for product' : 'Hide description for product', [props.ariaText]);

	return (
		<calcite-button class="prc__desc--show" onClick={props.onClick} appearance="transparent" icon-end={viewDescIcon} round="" label={viewDescAriaText}>
			<span>{viewDescText}</span>
		</calcite-button>
	);
}

export default CardDetailsToggle;
